<template>
  <v-app id="inspire">
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
        <v-row>
          <v-col  md="12" lg="12" cols="12">
            <v-card color="#393E46">
              <v-card-title>Reportes</v-card-title>
              <v-card-subtitle>Cumpleaños de la semana</v-card-subtitle>
              <v-card-actions>   <vue-excel-xlsx
                  class   = "btn"
                  :data="cumples"
                  :columns="columns"
                  file-name="Cumples"
                  :file-type="'xlsx'"
                  :sheet-name="'Cumples'"
              >
                <v-btn style="background-color: #6D9886;"> Bajar Excel</v-btn>
              </vue-excel-xlsx></v-card-actions>
              <v-card-text>
                <v-row>
                  <v-col  md="12" lg="12" cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="cumples"
                        class="elevation-1"
                        loading-text="Cargando... Por favor espere"
                        style="background-color: #393E46;"
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <leftmenu :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import leftmenu from '../../general/leftmenu';
import axios from "axios";
import firebase from 'firebase/compat/app';
import {mapGetters} from "vuex";
import Cabecerabaja from "@/components/general/cabecerabaja";


export default {
  title: 'Reportes Cumpleaños | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu
  },
  data: () => ({
    drawer: null,
    idnegocio: 0,
    token:'',
    fecha: null,
    abreviado:'NN',
    menu1: false,
    cumples:[],
    overlay:false,
    date: new Date().toISOString().substr(0, 10),
    columns : [
      {
        label: "Nombre",
        field: "nombre",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Telefono",
        field: "telefono",
      },
      {
        label: "Fecha de Nacimiento",
        field: "fechaNacimiento",
      },

      {
        label: "Tipo",
        field: "tipo",
      }
    ],
    headers: [
      { text: 'Nombre', value: 'nombre', sortable: true },
      { text: 'Email', value: 'email', sortable: true },
      { text: 'Telefono', value: 'telefono', sortable: true },
      { text: 'Fecha de Nacimiento', value: 'fechaNacimiento', sortable: true },
      { text: 'Tipo', value: 'tipo', sortable: true },
    ],
  }),
  mounted() {
    this.idnegocio =  this.$route.params.idnegocio;
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damecumples();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.damecumples();
    }
  },
  methods:{
    damecumples(){
      this.overlay = true;
      let urlfiesta = 'personas/cumples/' + this.idnegocio ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.cumples = response.data;
            this.overlay = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },

  },
  computed:{
    ...mapGetters({
      user: "user",
      usuario: "usuario"
    })
  }
};
</script>
